import React from "react";

const Facts = () => {
  return (
    <div className="counter">
      <div className="about_title">
        <h3>Fun Facts</h3>
      </div>

      <ul>
        <li>
          <div className="list_inner">
            <h3>Student exchange</h3>
            <span>Cúcuta, Colombia</span>
          </div>
        </li>

        <li>
          <div className="list_inner">
            <h3>Start up</h3>
            <span>Alpha</span>
          </div>
        </li>

        <li>
          <div className="list_inner">
            <h3>Certification</h3>
            <span>MTA Software</span>
          </div>
        </li>

        <li>
          <div className="list_inner">
            <h3>Master's degree</h3>
            <span>Starting a master's degree in game development</span>
          </div>
        </li>

        <li>
          <div className="list_inner">
            <h3>Semi-SR Frontend</h3>
            <span>Mainly in react</span>
          </div>
        </li>

        <li>
          <div className="list_inner">
            <h3>JR Game Dev</h3>
            <span>Unity</span>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default Facts;
